<template>
  <div>
    <h1>Your Lists</h1>
    <Checklists :token="$store.getters.getUserToken" :userSlug="this.$store.getters.getUserUserSlug" />
  </div>
</template>

<script>
import Checklists from '@/components/checklists.vue'

export default {
  name: 'UserChecklists',
  components: {
    Checklists
  },
  async created() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    }
  },
}
</script>
